import { React } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AppConstants from '../appConstants';

const NoActivePlanPopup = ({ modalStatus, handleClose }) => {
  const history = useHistory();
  const { planDetails, current } = useSelector((state) => state.user);
  const handleClickPlan = () => {
    history.push({
      pathname: AppConstants.routes.plans,
      state: {
        daysRemaining: planDetails.daysRemaining,
        currentPlan: planDetails.currentPlan
      }
    });
  };

  const handleCancel = async () => {
    handleClose(false);
  };

  return (
    <>
      <Modal
        className="filter-model PlanStatusModel"
        show={modalStatus}
        onHide={handleClose}
        centered
        // backdrop="static"
      >
        <Modal.Header>
          <Modal.Title className="w-100">
            <h5 className="modal-title text-center w-100">
              {`${
                planDetails?.currentPlan === ''
                  ? 'Activate plan'
                  : 'Plan expired'
              }`}
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Hey{' '}
            {`${current?.first_name || ''}`.trim()},
            {`${
              planDetails?.currentPlan === ''
                ? ' you need an active Lovrican plan to access this functionality. Do you want to activate your plan now?'
                : ' Your current Lovrican plan has already expired. To enjoy full functionality, please renew your subscription plan.'
            }`}
          </p>
          <div className="text-center">
            <button
              type="button"
              className="btn theme-btn themebtn1 mr-0"
              onClick={() => handleClickPlan()}
            >
              {`${
                planDetails?.currentPlan === '' ? 'Activate Plan' : 'Update Plan'
              }`}
            </button>
          </div>
          <div className="text-center">
            <button
              type="button"
              className="btn theme-btn themebtn2"
              onClick={() => handleCancel()}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default NoActivePlanPopup;
